//
// legal.js
//

import './translation';